export const batch4En = {
  "0132375d9a57": "Use my location",
  "01983f26074b": "Qty to deduct on completion",
  "021f7ccb8d3d": "Avg birth weight (kg)",
  "02727294ed85": "and create a new project (name it \"AJ Farm\").",
  "034a7bae70a5": "Mother tag ID (dam)",
  "03c2571f560f": "Scan an animal tag or an authorized employee code. Results contain only operational fields.",
  "03c283192cfa": "Vaccination Schedule ·",
  "042c862e4467": "Try again",
  "049e3ce5476a": "Assignee",
  "04b7b26c8ca2": "Critical",
  "055357a31ca6": "Target delivery",
  "05f2161b418c": "drive.file",
  "060be00f4f26": "All categories",
  "070e328ec8aa": "Uploading...",
  "079711ea16f3": "Employee",
  "07c2964c41f4": "Google Drive",
  "08c30fcc04d3": "Suspected diagnosis",
  "090ec5f560fc": "Tasks",
  "0948a33098e0": "Cost (PHP)",
  "0a474887b300": "Water quality",
  "0a8adac9d6d5": "Schedule",
  "0be720759ff0": "Revoke",
  "0bfac0bb1640": "Feed Since Last",
  "0c4e1d04a4a1": "Contact Phone",
  "0c5ef00834a8": "Expected Folder Categories",
  "0c62ba6f8de0": "Restart the backend and reload this page — the Connect button will appear.",
  "0c7a6cdc9e50": "New sign-ups can log in but cannot access the app until you approve them.",
  "0d4f769a368f": "Source Code → Drive",
  "0ea2a19f5694": "Veterinarian *",
  "0ee6f3decb15": "Line — Monthly Income vs Expense",
  "0eea57145e81": "Google credentials are configured. Click below to sign in with the Google account whose Drive should hold farm files.",
  "0f4895f5fbcd": "Describe what you saw…",
  "113f5ddb1051": "Your alerts",
  "11d56ea29108": "Agreed price (PHP)",
  "11d833a652a2": "Pregnant",
  "11dc9e195292": "Status:",
  "12748281e0f0": "Units",
  "12dea96fec20": "user",
  "1381ab06b60e": "Crop plot",
  "1389845b02c0": "kg",
  "1391014ab304": "Requested scopes:",
  "139dd46acc13": "Estimated due date",
  "143b179529ae": "Custom Fields",
  "158eadb6b85b": "SCAN ANIMAL QR",
  "1592a0703421": "waiting for an explicit retry.",
  "159edd2246da": "AI Task Advice",
  "15af1b1072dd": "Owner Name",
  "164761c4bd7d": "Photo / attachment (optional)",
  "173a5dadf4e7": "Assigned employee name",
  "175db723dfd6": "e.g. Pen 3 fence broken",
  "176628b94777": "Tasks · Reminders · Breeding · Events — color coded by category.",
  "17836b325826": "Assistance required",
  "1798b3ba42ee": "Completed",
  "1904ed248a58": "Deposit (PHP)",
  "1968649bce0e": "Employee attendance actions require management authorization.",
  "1a940eca136c": "Incident Reports",
  "1aa787fe0cfb": "preview",
  "1ad6c18921bf": "Google Cloud Console",
  "1af3b7799f1c": "Farm Name",
  "1b0a77e6bbea": "Today's Tasks",
  "1b24a75a007b": ", choose",
  "1b90271d66cf": "Progress",
  "1cd1bdad468f": "Scheduled",
  "1d0c8304baed": "Color",
  "1d75774c0f96": "Order",
  "1db775fdebdd": "Pen:",
  "1ea27782a820": "Selected animal",
  "1eda23758be9": "Administrator",
  "1f5a1abf2f08": "Complete",
  "2170afc55604": "Farm Logo",
  "226c7cd5e42b": "Vaccine *",
  "22edb691c36c": "Requested Scopes (minimum, least-privilege):",
  "23837eb44131": "Formulas",
  "23f77f32f50d": "Weight (kg) *",
  "24230b5f31bb": "KPI Number",
  "247b5cbc58fd": "Withdrawal date",
  "2485e6eb1cba": "Owner-only management. New users register via the Login page.",
  "24da69712fb2": "Google Sheets API",
  "25353db6f04b": "Failed breeding",
  "25c47fcbb74b": "GPS Location",
  "2745debaa64a": "Area",
  "2807a1b8372f": "No backups yet. Click \"Backup Now\" to create your first cloud snapshot.",
  "28445477d039": "Showing cached data",
  "285f62b21200": "my_metric",
  "28ba2e1813de": "APIs & Services → Library",
  "28c7da5a0ed0": "\" to start.",
  "294563c25f4e": "Temperature (C, optional)",
  "29a37cb1e915": "Temperature (deg C)",
  "2a268b89b83f": "Under",
  "2afb94d0898f": "No active notifications for this category.",
  "2b7e3ad7d073": "QR & Barcode Scanner",
  "2b894bd144da": "Icon (emoji)",
  "2bef525f9fb9": "Accent Color",
  "2bf73c3604d6": "Admin Settings",
  "2c3cafa4db3f": "File",
  "2c4e1babc2d1": "Client Secret",
  "2da0b68df884": "field",
  "2df48ad223be": "Last Login",
  "2f4979324e03": "Condition",
  "30c54a96f801": "Collection",
  "3142970c1419": "Contact Email",
  "315b39a0fc19": "KB",
  "31b9b3987172": "verified)",
  "320080b9ad01": "Birth weight (kg)",
  "3248151a7cdd": "Small (1 col)",
  "3281188351b8": "CSV",
  "3345867ecfee": "priority",
  "33ce417454bf": "Loading…",
  "346c87feb190": "Breed:",
  "34a79d015463": "Yield (kg)",
  "358e14a034cd": "Cause of death",
  "36a64afce728": "Google Drive Connected",
  "38683def9932": "Gestation / Incubation (days)",
  "389554673091": "Kanban",
  "38bd21ec32a0": "Report Incident",
  "3988dcb104c9": "e.g. Broiler House A",
  "3a3a224571d8": "Stillborn",
  "3a9bf18192a7": "Treatment name *",
  "3aac98402a70": "Weight Change",
  "3b906ae77c48": "— None —",
  "3bcc72e9a172": "Expected farrowing *",
  "3be0c08a7833": "Diagnosis",
  "3c363836cf4e": "d",
  "3d05ef2d0a42": "Downloads all currently recoverable AJ's Farm data and files to this device. Any unavailable historical files are listed in the backup manifest. Secrets are excluded.",
  "3d7ad2b86103": "Urgent Open",
  "3deb74565196": "Type",
  "3f0631d97412": "Area (hectares)",
  "3f66052a107e": "From",
  "41b81eb8db1b": "Approved",
  "43718b341634": "Credentials → Create Credentials → OAuth client ID",
  "439ff8e6fc5a": "Weak piglets",
  "44f6af694554": "Quantity",
  "453f30793bb5": "Body condition",
  "45833e303084": "Stages (comma-separated)",
  "45e7a1c379c7": "QR",
  "46e72c33d770": "Google Drive & Sheets",
  "46ebc1883a0c": "Ready to Connect",
  "47dcc27d6e87": "Roles",
  "47fcef440971": ", enable:",
  "488ecae3a1c3": "Pen 4, North Lot, Pond B",
  "489f4877244a": "Score",
  "492c257d99c4": "Service date *",
  "4999528efe0f": "Route",
  "4a12c0a38a37": "Connect Google Drive",
  "4abdfc6d463e": "pts",
  "4b631f698425": "Info",
  "4be37be90bfc": "Technical details",
  "4c9358d080ad": "Farrowing Pen",
  "4c96b3f2e11c": "The app will only see files it creates in your Drive. It cannot browse or modify anything else.",
  "4d4ce73b1566": "Card",
  "4da0c3de19e7": "submission",
  "4e0fa4378f15": "Poor",
  "4e26111f7ffa": "Primary preview",
  "4eaec4bc0f1d": "Owners",
  "4f30761a385b": "Estimated Minutes",
  "50282362745d": "Issue / Diagnosis *",
  "512f8825b4cc": "Notes (tap 🎤 to dictate)",
  "51c4d347bd7d": "Downloads a versioned JSON snapshot",
  "51cfe939b512": "5ml, 1 tab...",
  "523eeafcdf89": "Logo URL",
  "5258b0f1543f": "Resolved by",
  "5301648dcf6b": "Edit",
  "54bd9e0bc82a": "My Tasks",
  "54fd1711209f": "g",
  "55acfb2bd127": "Female ID (dam) *",
  "55d5d2dab9c3": "Full Recovery Backup",
  "55f8ebc805e6": "Description",
  "55f9626c6c05": "Add Field",
  "560040c54a3b": "AI",
  "560a4bd0f479": "Add Photo",
  "56e3badc4e6c": "Refresh",
  "5738f8965a57": "Treatment plan",
  "574c2d9fe3b6": "Vaccine name",
  "57f2b181d0a5": "Users",
  "5807dd602664": "logo",
  "599e350b1106": "Google Drive Setup Required",
  "59a91a7165d2": "Paste them into",
  "5a70e788e5eb": "Options (comma-separated)",
  "5aab6f03b04f": "Next due date",
  "5b5417c8f809": "Sort Order",
  "5c55dc1187df": "Vaccinations, medicine withdrawals, service reminders, low stock and expiring batches.",
  "5de21c05bd89": "No rules yet — add one below.",
  "5e2ba821e480": "Complications",
  "5faa59d4bc37": "Result",
  "5fad6696d4de": "Disposal",
  "5fc3bb63e1b3": "Batch / pen / house",
  "6111fbdb4f78": "Custom Metric",
  "61dedcf053ff": "Good",
  "61fd08ff5c37": "Sign Out",
  "62127687501d": "Please contact your farm Owner and let them know you're waiting. Once they approve you from the",
  "62b199007f1d": "Download every collection in one file. Store on your hard drive or upload to Google Drive.",
  "62f83bf42d3b": "Dose / strength",
  "632383067662": "Loading alerts...",
  "63ad1e932301": "Batch #",
  "6422dd054202": "Name / Email",
  "646db013dd91": "Animal ID (dam) *",
  "64b985898db9": "Fair",
  "64dfd68f1226": "Heat date",
  "64ed4adcf771": "Pick animal (optional)",
  "652d370d2331": "Issue / Observation *",
  "6648b48c681f": ". The farm Owner needs to approve your access before you can use the app.",
  "66c7734789e1": "Chart",
  "693622d7cad1": "e.g. Broiler House A · North corner",
  "69b9aa277782": "Fever, loss of appetite...",
  "69fa4490f352": "Feed since last (kg, optional)",
  "6a72085653e4": "All",
  "6af2ef649a46": "Select an action to continue.",
  "6b440cd50680": "Expiry date",
  "6d9f4c28dd8a": "Export Individual Modules",
  "6f9f011c5d36": "Longitude",
  "6fa926620c18": "Disease, injury, predation...",
  "7014243c1874": "Start Camera",
  "7015ab4fc4ea": "Lookup",
  "70440046a3dc": "Notes",
  "707d5f9c8662": "Quick entry — auto-saved and synced to office.",
  "709a23220f2c": "Name",
  "70b38feb2a35": "Add Card",
  "713032d9c7a1": "Buyer phone",
  "717606b3ddfb": "Medium (2 cols)",
  "71dd2eff9b4d": "Name:",
  "720f58fb1f93": "Formula",
  "74341e3c271d": "Label",
  "7505d64a54e0": "default",
  "753a22b2eb61": "Notifications",
  "754164850f38": "Configuration",
  "760853ffd22b": "Upload File to Drive",
  "76413b0251f1": "entries · newest first.",
  "768e0c1c6957": "Title",
  "777595adaace": "Loading assigned tasks…",
  "7776e6a0ff82": "Choose employee...",
  "77dfd2135f4d": "Cancel",
  "780cb0cfb0a2": "Cloud Backups & Source",
  "78f58c62ad53": "Roles & Permissions",
  "7a4690e818d2": "Animal tag, employee code, or barcode",
  "7adb6736cf2c": "Fill",
  "7adfcd13b3b0": "Manufacturer",
  "7ae7632852dc": "Route / method",
  "7b2c7f146aba": "Approve",
  "7ba0a4f030d1": "Pending Approval",
  "7bb0ddf9221c": "Task",
  "7cd5b9ea84fa": "Field Key",
  "7e47085008e8": "Mating method",
  "7eb1b417a689": "Growth Percentage",
  "7ef537a2316a": "Disposal method",
  "7f9bf082bf6a": "Clock Out",
  "7fbf37a3cf8e": "Repeat interval (days)",
  "8007defd3284": "Go home",
  "80ea156e1b83": "Healthy",
  "819f41f05837": "points",
  "825ce9e97dc4": "Workflows",
  "8270e6cbab43": "No users.",
  "82f3563458a5": "Farm Calendar",
  "8368712c026f": "Remaining Weight",
  "83a7238826ab": "Species",
  "84ee78e37e6a": "Feed quantity",
  "856399932c53": "spreadsheets",
  "856bf39480ed": "Accent preview",
  "85e57a7cc344": "Field Mode",
  "8754b869f855": "Location (free text)",
  "88306943fea7": "Method",
  "88373169e5fa": "Mummified",
  "886cbff9d9df": "Priority",
  "893ea9eb180d": "Date given",
  "89b86ab0e66f": "Language",
  "89d10cd6c1e1": "End date",
  "8a653cd514e0": "= your data (JSON snapshot).",
  "8a68d90802fa": "Go to",
  "8b20a6951162": "Assistance not required",
  "8bd9cf4070aa": "Medication name",
  "8c833df0ba02": "Water level / reading",
  "8c921c36b6a0": "Add this exact",
  "8cbaf00d9257": "Recovery status",
  "8cd9373697bb": "Symptoms",
  "8d1999570cd4": "Location / trough / pen",
  "8d1a6d814e76": "Search by email, name, or role…",
  "8d3e921408c8": "Clock In",
  "8d886c0ba6f2": "Something went wrong",
  "8dd644347f3f": "GPS:",
  "8e3ad23b5e66": "Upload to Drive",
  "8e54dc5331b0": "Barcode",
  "8eeb5bd05563": "Web application",
  "905cb326c779": "You",
  "924c045d68d5": "Custom Metrics",
  "929a5e45f98a": "Describe what happened. Attach up to 5 photos and capture your GPS location.",
  "92c79c26941e": "Farm Information",
  "931cd0b708ee": "Current Weight",
  "93a23b2c70b0": "Species (optional)",
  "93de82546383": "Live born",
  "94c903355df3": "Google Drive API",
  "94dd9e08c129": "Hi",
  "9616975c7a0e": "Title *",
  "96169cd67a1e": "Estimated FCR",
  "96f608c16cef": "Pending",
  "97ef8b86f35b": "/app/backend/.env",
  "9815c7072808": "Pick animal",
  "987b9ced08d4": "Day",
  "9a95a36384c2": "Dam / mother",
  "9c6854a11b77": "Feed type / ration",
  "9e253470c876": "Stop",
  "9e50be33c302": "Administered by",
  "9f1362cde54e": "Admin Dashboard",
  "9f4fd4f71409": "Download Full Backup",
  "9f5c08dbfa48": "No incidents in this view.",
  "9f8a2389a20c": "User",
  "a028fce203b4": "Total Users",
  "a08e11119aef": "Excel",
  "a1993bdd2c70": "amount, weight_kg...",
  "a1a1e1eb0b47": "No cards yet.",
  "a1b308ec704a": "Due Date",
  "a1c02c6571aa": "Copy the generated",
  "a1c4a9e7f224": "downloads all currently recoverable AJ's Farm data and files to this device. Any unavailable historical files are listed in the backup manifest. Secrets are excluded.",
  "a1fdaa6b2a84": "Operations",
  "a1fffaaafb7c": "List",
  "a26a5714a97f": "Heat, Breeding, Pregnancy Check, Gestation, Farrowing",
  "a3c686e711e4": "Category",
  "a416c837d99b": "Or enter code manually",
  "a4730a22cf49": "Staff",
  "a539194be231": "Dam ID *",
  "a6886107051f": "Additional Notes",
  "a703ae27575c": "Field Tool",
  "a733b809d2f1": "Active",
  "a766cd7ff02c": "Client ID",
  "a85dbb248b0c": "Buyer name *",
  "a8f71f6ec3cd": "Animal ·",
  "a92db57e837c": "Needs treatment",
  "aa3e02d38002": "Value / Expression",
  "ac06ef9ee1f3": "Account:",
  "ac8f31224ab0": "Current weight",
  "accf40c89baa": "Created",
  "ad9bef8ad18e": "OAuth consent screen",
  "ae8c3939382f": "Reminders",
  "aea2acee58c1": "Authorized redirect URI",
  "aeda8054074a": "Choose a module and format. Opens Save-As dialog in your browser.",
  "aee9f02c9b71": "All active alerts",
  "b05b84880e32": "Save Branding",
  "b09f1110b8bf": "Large (3-4 cols)",
  "b0b0baa36b8f": "Full Access",
  "b0b1033a5d0c": "Card Type",
  "b1590d210090": "Aborted",
  "b16a33824cdb": "Animal ID *",
  "b1786d43e65e": "Weight/Pts",
  "b1a5954a483f": "High",
  "b25928c69902": "Total",
  "b2bb7604c825": "Metric",
  "b2eefdbf3b29": "Empty. Click \"",
  "b33fc83f3d94": "Medicine *",
  "b3c57561b101": "Visit type",
  "b3c75ecfcf4b": "GPS Coordinates",
  "b41cf063eca8": "Scheduled date",
  "b46706354351": "Amount (PHP) *",
  "b484d4783e79": "Veterinarian notes",
  "b4c7298aaddd": "No authorized farm events are scheduled for this calendar.",
  "b5600c5378e4": "Users (",
  "b6443c996d50": "Loading users…",
  "b7152342a267": "Size",
  "b7469682e86f": "View Full Record",
  "b7504d4a57aa": "weaning, sale, quarantine...",
  "b77d3190bd45": "Withdrawal ends",
  "b87a1929f78b": "Reminder",
  "b8da11963e47": "Follow-up date",
  "b92a577b5dfa": "Loading Drive status...",
  "b9ba037c0e4c": "Aggregation",
  "b9d5d070e883": "No alerts.",
  "b9f456e8b0f9": "Assigned work only.",
  "bae7d5be7082": "Status",
  "bb37dabe3e19": "· by",
  "bbfa773e5a63": "Close",
  "bc6ba0d1bbf5": "All priorities",
  "bdd143cbfa6a": "GPS optional",
  "be6b37bac29a": "Assistance",
  "c110df7ef9e2": "Vaccine name *",
  "c1481b778dcf": "Checklist (one per line)",
  "c16049cead4f": "waiting for approval",
  "c17097d55a67": "These are required categories, not proof of physical Drive folders. Verified mapping:",
  "c1c785eaec5f": "No tasks yet.",
  "c28adc5def0e": "Photos (up to 5)",
  "c326a4660b67": "Field",
  "c3b69e661eec": "Choose…",
  "c3cd636a585b": "Actions",
  "c3e9bd0582df": "Submitted at",
  "c3f104d13657": "Role",
  "c40810f5c31d": "Quick Actions",
  "c4d9d145efc1": "To *",
  "c57627ab8ffd": "No Field Mode actions are enabled for your role. Ask the owner to grant access from Admin Settings → Customization → Field Mode Access.",
  "c5db3d91c4cb": "Crop",
  "c67dd20ee842": "Key",
  "c6a143441b52": "Uncertain",
  "c7b3d4127c30": "Feed pigs Clean pens Refill water",
  "c83ecaf035fc": "Snapshot of species, custom fields, formulas, dashboard cards, roles, and Field Mode access.",
  "c99a2bcf3e71": "Observe",
  "ca9b7e7e1f0d": "Findings",
  "caa155adf81f": "rules",
  "cb440b412169": "= full app code (.tar.gz) — download, extract, and push to your own GitHub.",
  "cba41814177b": "lb",
  "cc3dbd47e1cf": "New Task",
  "cc8da61915b7": "Attachment preview",
  "cda8cc502497": "+ Add Rule",
  "ce1911fa1f05": "When a new animal is registered with a birth date, tasks auto-generate on the days below.",
  "ce63999e7faf": "Follow these one-time steps to enable cloud backups, Sheets sync, and file uploads.",
  "ced3905ec822": "Latitude",
  "cf1c85adba54": "Position",
  "cf362a665a82": "Review & Retry",
  "cf9b77061f7b": "Open",
  "cffa50a32cb1": "and",
  "d06d55570938": "Permissions",
  "d0c31e3e846d": "Litter size",
  "d0e03a9704cf": "Signed up as:",
  "d0efe0b2c75c": "Alerts",
  "d14349309573": "Add photo",
  "d17dc3843de8": "Branding",
  "d1c69a859a96": "Last",
  "d1f7dc891b5e": "Timezone",
  "d24983206285": "Weight (kg)",
  "d296a30a06e6": "Download JSON",
  "d3197241f50e": "Location / Pen / Pond",
  "d36f1955ad71": "Date *",
  "d3dcce7d1024": "Primary Color",
  "d404968ea90b": "Medium",
  "d45543933c89": ". New entries will save when back online.",
  "d67fc57affe1": "Sync to Google Sheets",
  "d6bfe7918d9b": "Vaccine / medicine name",
  "d70f93df5e8f": "Address",
  "d7a484140f5f": "Workflow",
  "d7f0ac9e0072": "Customization",
  "d858aa5abb0a": "Expected farrowing",
  "d87f47b47e4d": "Dashboard",
  "d8c107902a1e": "Chart Type",
  "d8d9713fb27f": "The page hit an unexpected error. Your data is safe.",
  "d999aeb0545f": "Resolved",
  "da287a6991f2": "No templates in this category yet.",
  "da2e1b8c194d": "Dashboard Cards",
  "da7f99e8cbbf": "Dose",
  "dacfa24d0868": "Pie — Animals by Species",
  "dadccfb55b81": "GOOGLE_CLIENT_SECRET=\"GOCSPX-xxxxx\"",
  "db1affa5c28e": "Folder mapping:",
  "db3ade5935b6": "Farm Info",
  "dcb45acec258": "No assigned tasks.",
  "dcba9bbe1198": "Camera Scanner",
  "ddf6a1f0ce8c": "Metrics",
  "df280e8d1006": "Inventory item ID",
  "dfb1cdc86ff6": "Check date *",
  "e0637047e8b6": "Reported by",
  "e070de224434": "Currency",
  "e0cd87951b95": "Assigned employee ID",
  "e1301ae09132": "Full Farm Backup",
  "e13d1660c248": "Backup Now",
  "e154cb584579": "Target Weight",
  "e184a42b6a65": "Download Excel (.xlsx)",
  "e24e824b6811": "Assigned",
  "e29a79fe0c34": "Review",
  "e301dd6062f7": "Sex",
  "e542695cd353": "No tasks",
  "e570a2dc1297": ", sign out and back in — you'll have access.",
  "e5af0395ec56": "Sex:",
  "e5efd304560a": "none, manual, c-section",
  "e5fac98e866d": "Approve new sign-ups. Revoke access. Manage every account on your farm — Owner-only.",
  "e603caadf1f7": "Admin Dashboard · User Management",
  "e6d03272a321": "Technician",
  "e6f600b0f54a": "Google Drive folders need initialization",
  "e81a853e3e60": "Numeric Field",
  "e894481d9eed": "Alerts Center",
  "e8b685271238": "Fields",
  "e8f43bc66219": "No submissions yet. Fill out a template to record one.",
  "e9b1ac9b5406": "Loading farm calendar…",
  "e9bbbb24aa89": "Save Schedule",
  "e9c45563358e": "Warning",
  "ea26876daa9a": "Natural",
  "ead4b6ef39d4": "Configure the",
  "eada007127e6": "Input / water source",
  "eb5e474d1376": "Cause *",
  "eb9a4bc1c0c1": "Date",
  "ecb26f46e394": "Urgent",
  "ecfdad01c3a0": "Your account is pending approval",
  "ed28e0686e12": "Disconnect",
  "ed486d652fb9": "Signed Up",
  "ee45c30326b7": "Report",
  "eed6bfb41051": "Required",
  "ef2c495072dd": "New Weight",
  "efc007a393f6": "Save",
  "f0cb1033c6f1": "Nursery A",
  "f0d72cd740a1": "No audit entries.",
  "f2049c0902fc": "GOOGLE_CLIENT_ID=\"xxxxxxx.apps.googleusercontent.com\"",
  "f219cc0614ae": "Reason",
  "f2c6b564bd81": "Section",
  "f2cc30b13d8e": "Fields (",
  "f3355e26c1d6": "Cough, diarrhea, wound...",
  "f353276e0c59": "Not pregnant",
  "f3ddba3372dd": "tab.",
  "f456d73d894a": "Not recognized as animal tag or employee code",
  "f549dc5349fc": "Urgent items that need attention.",
  "f6b935ab3371": "Unit",
  "f8344ea1a802": "Thank you for signing up,",
  "f8760a38ce49": "Plot name",
  "f8ed4fb0315f": "Cloud backup, PDF uploads, and Sheets sync are live — configure in the",
  "f9060f3f823d": "Scan or enter a code to see details.",
  "fa2984b367b8": "Save Changes",
  "fb91e24fa52d": "Update",
  "fba889c720a6": "Male ID (sire) *",
  "fbd71ca491cf": "Dosage",
  "fd1cf782f0a4": "Sire / father (optional)",
  "fd369935a258": "Data Export",
  "fd5b5995a579": "(External) — set app name \"AJ Farm\", your email, and add yourself as a Test User.",
  "fe6434c4ba45": "Metric Key (unique)",
  "ff99f5b5f794": "Start date",
  "ffcd11eb56e9": "Loss (PHP)"
};

export const batch4Tl = {
  "0132375d9a57": "Use my location",
  "01983f26074b": "Qty to deduct on completion",
  "021f7ccb8d3d": "Avg birth weight (kg)",
  "02727294ed85": "and create a new project (name it \"AJ Farm\").",
  "034a7bae70a5": "Mother tag ID (dam)",
  "03c2571f560f": "Scan an animal tag or an authorized employee code. Results contain only operational fields.",
  "03c283192cfa": "Vaccination Schedule ·",
  "042c862e4467": "Try again",
  "049e3ce5476a": "Nakatakdang Gumawa",
  "04b7b26c8ca2": "Kritikal",
  "055357a31ca6": "Target delivery",
  "05f2161b418c": "drive.file",
  "060be00f4f26": "Lahat ng kategorya",
  "070e328ec8aa": "Uploading...",
  "079711ea16f3": "Empleyado",
  "07c2964c41f4": "Google Drive",
  "08c30fcc04d3": "Suspected diagnosis",
  "090ec5f560fc": "Mga Gawain",
  "0948a33098e0": "Cost (PHP)",
  "0a474887b300": "Water quality",
  "0a8adac9d6d5": "Schedule",
  "0be720759ff0": "Revoke",
  "0bfac0bb1640": "Feed Since Last",
  "0c4e1d04a4a1": "Telepono ng Kontak",
  "0c5ef00834a8": "Mga Inaasahang Kategorya ng Folder",
  "0c62ba6f8de0": "Restart the backend and reload this page — the Connect button will appear.",
  "0c7a6cdc9e50": "Bagong sign-ups can log in but cannot access the app until you approve them.",
  "0d4f769a368f": "Source Code → Drive",
  "0ea2a19f5694": "Veterinarian *",
  "0ee6f3decb15": "Line — Monthly Income vs Expense",
  "0eea57145e81": "Naka-configure ang Google credentials. Mag-sign in sa ibaba gamit ang Google account na paglalagyan ng mga file ng bukid.",
  "0f4895f5fbcd": "Ilarawan ang iyong nakita…",
  "113f5ddb1051": "Your alerts",
  "11d56ea29108": "Agreed price (PHP)",
  "11d833a652a2": "Pregnant",
  "11dc9e195292": "Status:",
  "12748281e0f0": "Units",
  "12dea96fec20": "user",
  "1381ab06b60e": "Crop plot",
  "1389845b02c0": "kg",
  "1391014ab304": "Requested scopes:",
  "139dd46acc13": "Estimated due date",
  "143b179529ae": "Mga Custom Field",
  "158eadb6b85b": "SCAN ANIMAL QR",
  "1592a0703421": "waiting for an explicit retry.",
  "159edd2246da": "AI Gawain Advice",
  "15af1b1072dd": "Owner Pangalan",
  "164761c4bd7d": "Photo / attachment (optional)",
  "173a5dadf4e7": "Nakatalaga employee name",
  "175db723dfd6": "e.g. Pen 3 fence broken",
  "176628b94777": "Mga Gawain · Reminders · Breeding · Events — color coded by category.",
  "17836b325826": "Kailangan ng tulong",
  "1798b3ba42ee": "Tapos na",
  "1904ed248a58": "Deposit (PHP)",
  "1968649bce0e": "Nangangailangan ng pahintulot ng management ang mga attendance action ng empleyado.",
  "1a940eca136c": "Mga Ulat ng Insidente",
  "1aa787fe0cfb": "preview",
  "1ad6c18921bf": "Google Cloud Console",
  "1af3b7799f1c": "Pangalan ng Bukid",
  "1b0a77e6bbea": "Today's Mga Gawain",
  "1b24a75a007b": ", choose",
  "1b90271d66cf": "Progress",
  "1cd1bdad468f": "Scheduled",
  "1d0c8304baed": "Color",
  "1d75774c0f96": "Order",
  "1db775fdebdd": "Pen:",
  "1ea27782a820": "Selected animal",
  "1eda23758be9": "Tagapangasiwa",
  "1f5a1abf2f08": "Kumpletuhin",
  "2170afc55604": "Logo ng Bukid",
  "226c7cd5e42b": "Vaccine *",
  "22edb691c36c": "Requested Scopes (minimum, least-privilege):",
  "23837eb44131": "Formulas",
  "23f77f32f50d": "Weight (kg) *",
  "24230b5f31bb": "KPI Number",
  "247b5cbc58fd": "Withdrawal date",
  "2485e6eb1cba": "Owner-only management. Bagong users register via the Login page.",
  "24da69712fb2": "Google Sheets API",
  "25353db6f04b": "Nabigo breeding",
  "25c47fcbb74b": "GPS Location",
  "2745debaa64a": "Area",
  "2807a1b8372f": "Walang backups yet. Click \"Backup Now\" to create your first cloud snapshot.",
  "28445477d039": "Showing cached data",
  "285f62b21200": "my_metric",
  "28ba2e1813de": "APIs & Services → Library",
  "28c7da5a0ed0": "\" to start.",
  "294563c25f4e": "Temperature (C, optional)",
  "29a37cb1e915": "Temperature (deg C)",
  "2a268b89b83f": "Under",
  "2afb94d0898f": "Walang active notifications for this category.",
  "2b7e3ad7d073": "QR & Barcode Scanner",
  "2b894bd144da": "Icon (emoji)",
  "2bef525f9fb9": "Accent Color",
  "2bf73c3604d6": "Mga Setting ng Admin",
  "2c3cafa4db3f": "File",
  "2c4e1babc2d1": "Client Secret",
  "2da0b68df884": "field",
  "2df48ad223be": "Last Login",
  "2f4979324e03": "Condition",
  "30c54a96f801": "Collection",
  "3142970c1419": "Email ng Kontak",
  "315b39a0fc19": "KB",
  "31b9b3987172": "verified)",
  "320080b9ad01": "Birth weight (kg)",
  "3248151a7cdd": "Small (1 col)",
  "3281188351b8": "CSV",
  "3345867ecfee": "priority",
  "33ce417454bf": "Naglo-load…",
  "346c87feb190": "Breed:",
  "34a79d015463": "Yield (kg)",
  "358e14a034cd": "Cause of death",
  "36a64afce728": "Google Drive Nakakonekta",
  "38683def9932": "Gestation / Incubation (days)",
  "389554673091": "Kanban",
  "38bd21ec32a0": "Report Insidente",
  "3988dcb104c9": "e.g. Broiler House A",
  "3a3a224571d8": "Stillborn",
  "3a9bf18192a7": "Treatment name *",
  "3aac98402a70": "Weight Change",
  "3b906ae77c48": "— Wala —",
  "3bcc72e9a172": "Expected farrowing *",
  "3be0c08a7833": "Diagnosis",
  "3c363836cf4e": "d",
  "3d05ef2d0a42": "Downloads all currently recoverable AJ's Farm data and files to this device. Any unavailable historical files are listed in the backup manifest. Secrets are excluded.",
  "3d7ad2b86103": "Urgent Open",
  "3deb74565196": "Type",
  "3f0631d97412": "Area (hectares)",
  "3f66052a107e": "From",
  "41b81eb8db1b": "Aprubado",
  "43718b341634": "Credentials → Gumawa Credentials → OAuth client ID",
  "439ff8e6fc5a": "Weak piglets",
  "44f6af694554": "Quantity",
  "453f30793bb5": "Body condition",
  "45833e303084": "Stages (comma-separated)",
  "45e7a1c379c7": "QR",
  "46e72c33d770": "Google Drive & Sheets",
  "46ebc1883a0c": "Ready to Connect",
  "47dcc27d6e87": "Mga Role",
  "47fcef440971": ", enable:",
  "488ecae3a1c3": "Pen 4, North Lot, Pond B",
  "489f4877244a": "Score",
  "492c257d99c4": "Service date *",
  "4999528efe0f": "Route",
  "4a12c0a38a37": "Ikonekta ang Google Drive",
  "4abdfc6d463e": "pts",
  "4b631f698425": "Info",
  "4be37be90bfc": "Technical details",
  "4c9358d080ad": "Farrowing Pen",
  "4c96b3f2e11c": "The app will only see files it creates in your Drive. It cannot browse or modify anything else.",
  "4d4ce73b1566": "Card",
  "4da0c3de19e7": "submission",
  "4e0fa4378f15": "Poor",
  "4e26111f7ffa": "Primary preview",
  "4eaec4bc0f1d": "Owners",
  "4f30761a385b": "Estimated Minutes",
  "50282362745d": "Issue / Diagnosis *",
  "512f8825b4cc": "Notes (tap 🎤 to dictate)",
  "51c4d347bd7d": "Nagda-download ng may bersyong JSON snapshot",
  "51cfe939b512": "5ml, 1 tab...",
  "523eeafcdf89": "Logo URL",
  "5258b0f1543f": "Resolved by",
  "5301648dcf6b": "I-edit",
  "54bd9e0bc82a": "Aking mga Gawain",
  "54fd1711209f": "g",
  "55acfb2bd127": "Female ID (dam) *",
  "55d5d2dab9c3": "Buong Recovery Backup",
  "55f8ebc805e6": "Paglalarawan",
  "55f9626c6c05": "Magdagdag ng Field",
  "560040c54a3b": "AI",
  "560a4bd0f479": "Magdagdag ng Photo",
  "56e3badc4e6c": "I-refresh",
  "5738f8965a57": "Treatment plan",
  "574c2d9fe3b6": "Vaccine name",
  "57f2b181d0a5": "Mga User",
  "5807dd602664": "logo",
  "599e350b1106": "Google Drive Setup Kinakailangan",
  "59a91a7165d2": "Paste them into",
  "5a70e788e5eb": "Options (comma-separated)",
  "5aab6f03b04f": "Next due date",
  "5b5417c8f809": "Sort Order",
  "5c55dc1187df": "Vaccinations, medicine withdrawals, service reminders, low stock and expiring batches.",
  "5de21c05bd89": "Walang rules yet — add one below.",
  "5e2ba821e480": "Complications",
  "5faa59d4bc37": "Result",
  "5fad6696d4de": "Disposal",
  "5fc3bb63e1b3": "Batch / pen / house",
  "6111fbdb4f78": "Custom na Sukatan",
  "61dedcf053ff": "Good",
  "61fd08ff5c37": "Sign Out",
  "62127687501d": "Please contact your farm Owner and let them know you're waiting. Once they approve you from the",
  "62b199007f1d": "I-download ang bawat collection sa isang file. Itago sa hard drive o i-upload sa Google Drive.",
  "62f83bf42d3b": "Dose / strength",
  "632383067662": "Naglo-load alerts...",
  "63ad1e932301": "Batch #",
  "6422dd054202": "Pangalan / Email",
  "646db013dd91": "Animal ID (dam) *",
  "64b985898db9": "Fair",
  "64dfd68f1226": "Heat date",
  "64ed4adcf771": "Pick animal (optional)",
  "652d370d2331": "Issue / Observation *",
  "6648b48c681f": ". The farm Owner needs to approve your access before you can use the app.",
  "66c7734789e1": "Chart",
  "693622d7cad1": "e.g. Broiler House A · North corner",
  "69b9aa277782": "Fever, loss of appetite...",
  "69fa4490f352": "Feed since last (kg, optional)",
  "6a72085653e4": "Lahat",
  "6af2ef649a46": "Pumili an action to continue.",
  "6b440cd50680": "Expiry date",
  "6d9f4c28dd8a": "I-export ang Indibidwal na Module",
  "6f9f011c5d36": "Longitude",
  "6fa926620c18": "Disease, injury, predation...",
  "7014243c1874": "Simula Camera",
  "7015ab4fc4ea": "Lookup",
  "70440046a3dc": "Mga Tala",
  "707d5f9c8662": "Quick entry — auto-saved and synced to office.",
  "709a23220f2c": "Pangalan",
  "70b38feb2a35": "Magdagdag ng Card",
  "713032d9c7a1": "Buyer phone",
  "717606b3ddfb": "Medium (2 cols)",
  "71dd2eff9b4d": "Pangalan:",
  "720f58fb1f93": "Formula",
  "74341e3c271d": "Label",
  "7505d64a54e0": "default",
  "753a22b2eb61": "Mga Notification",
  "754164850f38": "Configuration",
  "760853ffd22b": "Mag-upload ng File sa Drive",
  "76413b0251f1": "entries · newest first.",
  "768e0c1c6957": "Pamagat",
  "777595adaace": "Naglo-load assigned tasks…",
  "7776e6a0ff82": "Pumili ng empleyado...",
  "77dfd2135f4d": "Kanselahin",
  "780cb0cfb0a2": "Cloud Backup at Source",
  "78f58c62ad53": "Mga Role & Permissions",
  "7a4690e818d2": "Animal tag, employee code, or barcode",
  "7adb6736cf2c": "Fill",
  "7adfcd13b3b0": "Manufacturer",
  "7ae7632852dc": "Route / method",
  "7b2c7f146aba": "Aprubahan",
  "7ba0a4f030d1": "Nakabinbin Approval",
  "7bb0ddf9221c": "Gawain",
  "7cd5b9ea84fa": "Field Key",
  "7e47085008e8": "Mating method",
  "7eb1b417a689": "Growth Percentage",
  "7ef537a2316a": "Disposal method",
  "7f9bf082bf6a": "Clock Out",
  "7fbf37a3cf8e": "Repeat interval (days)",
  "8007defd3284": "Bumalik sa home",
  "80ea156e1b83": "Healthy",
  "819f41f05837": "points",
  "825ce9e97dc4": "Workflows",
  "8270e6cbab43": "Walang users.",
  "82f3563458a5": "Kalendaryo ng Bukid",
  "8368712c026f": "Remaining Weight",
  "83a7238826ab": "Species",
  "84ee78e37e6a": "Feed quantity",
  "856399932c53": "spreadsheets",
  "856bf39480ed": "Accent preview",
  "85e57a7cc344": "Field Mode",
  "8754b869f855": "Location (free text)",
  "88306943fea7": "Method",
  "88373169e5fa": "Mummified",
  "886cbff9d9df": "Prayoridad",
  "893ea9eb180d": "Petsa given",
  "89b86ab0e66f": "Wika",
  "89d10cd6c1e1": "Wakas date",
  "8a653cd514e0": "= your data (JSON snapshot).",
  "8a68d90802fa": "Go to",
  "8b20a6951162": "Hindi kailangan ng tulong",
  "8bd9cf4070aa": "Medication name",
  "8c833df0ba02": "Water level / reading",
  "8c921c36b6a0": "Magdagdag ng this exact",
  "8cbaf00d9257": "Recovery status",
  "8cd9373697bb": "Symptoms",
  "8d1999570cd4": "Location / trough / pen",
  "8d1a6d814e76": "Maghanap by email, name, or role…",
  "8d3e921408c8": "Clock In",
  "8d886c0ba6f2": "Something went wrong",
  "8dd644347f3f": "GPS:",
  "8e3ad23b5e66": "I-upload to Drive",
  "8e54dc5331b0": "Barcode",
  "8eeb5bd05563": "Web application",
  "905cb326c779": "You",
  "924c045d68d5": "Mga Custom na Sukatan",
  "929a5e45f98a": "Ilarawan ang nangyari. Maglakip ng hanggang 5 larawan at kunin ang iyong lokasyon sa GPS.",
  "92c79c26941e": "Impormasyon ng Bukid",
  "931cd0b708ee": "Current Weight",
  "93a23b2c70b0": "Species (optional)",
  "93de82546383": "Live born",
  "94c903355df3": "Google Drive API",
  "94dd9e08c129": "Hi",
  "9616975c7a0e": "Title *",
  "96169cd67a1e": "Estimated FCR",
  "96f608c16cef": "Nakabinbin",
  "97ef8b86f35b": "/app/backend/.env",
  "9815c7072808": "Pick animal",
  "987b9ced08d4": "Araw",
  "9a95a36384c2": "Dam / mother",
  "9c6854a11b77": "Feed type / ration",
  "9e253470c876": "Stop",
  "9e50be33c302": "Administered by",
  "9f1362cde54e": "Dashboard ng Admin",
  "9f4fd4f71409": "I-download ang Full Backup",
  "9f5c08dbfa48": "Walang incidents in this view.",
  "9f8a2389a20c": "User",
  "a028fce203b4": "Total Mga User",
  "a08e11119aef": "Excel",
  "a1993bdd2c70": "amount, weight_kg...",
  "a1a1e1eb0b47": "Walang cards yet.",
  "a1b308ec704a": "Takdang Petsa",
  "a1c02c6571aa": "Copy the generated",
  "a1c4a9e7f224": "dina-download ang lahat ng kasalukuyang mare-recover na data at file ng AJ's Farm sa device na ito. Nakalista sa backup manifest ang mga dating file na hindi available. Hindi kasama ang mga secret.",
  "a1fdaa6b2a84": "Operations",
  "a1fffaaafb7c": "List",
  "a26a5714a97f": "Heat, Breeding, Pregnancy Check, Gestation, Farrowing",
  "a3c686e711e4": "Kategorya",
  "a416c837d99b": "Or enter code manually",
  "a4730a22cf49": "Staff",
  "a539194be231": "Dam ID *",
  "a6886107051f": "Additional Notes",
  "a703ae27575c": "Field Tool",
  "a733b809d2f1": "Aktibo",
  "a766cd7ff02c": "Client ID",
  "a85dbb248b0c": "Buyer name *",
  "a8f71f6ec3cd": "Animal ·",
  "a92db57e837c": "Needs treatment",
  "aa3e02d38002": "Value / Expression",
  "ac06ef9ee1f3": "Account:",
  "ac8f31224ab0": "Kasalukuyang timbang",
  "accf40c89baa": "Nagawa",
  "ad9bef8ad18e": "OAuth consent screen",
  "ae8c3939382f": "Reminders",
  "aea2acee58c1": "Authorized redirect URI",
  "aeda8054074a": "Choose a module and format. Opens I-save-As dialog in your browser.",
  "aee9f02c9b71": "Lahat ng aktibong alerto",
  "b05b84880e32": "I-save Branding",
  "b09f1110b8bf": "Large (3-4 cols)",
  "b0b0baa36b8f": "Full Access",
  "b0b1033a5d0c": "Card Type",
  "b1590d210090": "Aborted",
  "b16a33824cdb": "Animal ID *",
  "b1786d43e65e": "Weight/Pts",
  "b1a5954a483f": "Mataas",
  "b25928c69902": "Total",
  "b2bb7604c825": "Metric",
  "b2eefdbf3b29": "Empty. Click \"",
  "b33fc83f3d94": "Medicine *",
  "b3c57561b101": "Visit type",
  "b3c75ecfcf4b": "GPS Coordinates",
  "b41cf063eca8": "Scheduled date",
  "b46706354351": "Amount (PHP) *",
  "b484d4783e79": "Veterinarian notes",
  "b4c7298aaddd": "Walang authorized farm events are scheduled for this calendar.",
  "b5600c5378e4": "Mga User (",
  "b6443c996d50": "Naglo-load users…",
  "b7152342a267": "Size",
  "b7469682e86f": "Tingnan Full Record",
  "b7504d4a57aa": "weaning, sale, quarantine...",
  "b77d3190bd45": "Withdrawal ends",
  "b87a1929f78b": "Reminder",
  "b8da11963e47": "Follow-up date",
  "b92a577b5dfa": "Naglo-load Drive status...",
  "b9ba037c0e4c": "Aggregation",
  "b9d5d070e883": "Walang alerts.",
  "b9f456e8b0f9": "Nakatalagang trabaho lamang.",
  "bae7d5be7082": "Katayuan",
  "bb37dabe3e19": "· by",
  "bbfa773e5a63": "Isara",
  "bc6ba0d1bbf5": "Lahat ng prayoridad",
  "bdd143cbfa6a": "GPS optional",
  "be6b37bac29a": "Tulong",
  "c110df7ef9e2": "Vaccine name *",
  "c1481b778dcf": "Checklist (one per line)",
  "c16049cead4f": "waiting for approval",
  "c17097d55a67": "These are required categories, not proof of physical Drive folders. Verified mapping:",
  "c1c785eaec5f": "Walang tasks yet.",
  "c28adc5def0e": "Photos (up to 5)",
  "c326a4660b67": "Field",
  "c3b69e661eec": "Pumili…",
  "c3cd636a585b": "Mga Aksyon",
  "c3e9bd0582df": "Submitted at",
  "c3f104d13657": "Role",
  "c40810f5c31d": "Quick Actions",
  "c4d9d145efc1": "To *",
  "c57627ab8ffd": "Walang Field Mode actions are enabled for your role. Ask the owner to grant access from Admin Settings → Customization → Field Mode Access.",
  "c5db3d91c4cb": "Crop",
  "c67dd20ee842": "Key",
  "c6a143441b52": "Uncertain",
  "c7b3d4127c30": "Feed pigs Clean pens Refill water",
  "c83ecaf035fc": "Snapshot of species, custom fields, formulas, dashboard cards, roles, and Field Mode access.",
  "c99a2bcf3e71": "Observe",
  "ca9b7e7e1f0d": "Findings",
  "caa155adf81f": "rules",
  "cb440b412169": "= full app code (.tar.gz) — download, extract, and push to your own GitHub.",
  "cba41814177b": "lb",
  "cc3dbd47e1cf": "Bagong Gawain",
  "cc8da61915b7": "Preview ng kalakip",
  "cda8cc502497": "+ Magdagdag ng Rule",
  "ce1911fa1f05": "When a new animal is registered with a birth date, tasks auto-generate on the days below.",
  "ce63999e7faf": "Sundin ang mga minsanang hakbang na ito upang paganahin ang cloud backup, Sheets sync, at pag-upload ng file.",
  "ced3905ec822": "Latitude",
  "cf1c85adba54": "Position",
  "cf362a665a82": "Review & Retry",
  "cf9b77061f7b": "Buksan",
  "cffa50a32cb1": "and",
  "d06d55570938": "Mga Pahintulot",
  "d0c31e3e846d": "Litter size",
  "d0e03a9704cf": "Signed up as:",
  "d0efe0b2c75c": "Mga Alerto",
  "d14349309573": "Magdagdag ng photo",
  "d17dc3843de8": "Pagba-brand",
  "d1c69a859a96": "Last",
  "d1f7dc891b5e": "Timezone",
  "d24983206285": "Weight (kg)",
  "d296a30a06e6": "I-download ang JSON",
  "d3197241f50e": "Location / Pen / Pond",
  "d36f1955ad71": "Petsa *",
  "d3dcce7d1024": "Primary Color",
  "d404968ea90b": "Katamtaman",
  "d45543933c89": ". Bagong entries will save when back online.",
  "d67fc57affe1": "I-sync sa Google Sheets",
  "d6bfe7918d9b": "Vaccine / medicine name",
  "d70f93df5e8f": "Address",
  "d7a484140f5f": "Workflow",
  "d7f0ac9e0072": "Pag-customize",
  "d858aa5abb0a": "Expected farrowing",
  "d87f47b47e4d": "Dashboard",
  "d8c107902a1e": "Chart Type",
  "d8d9713fb27f": "The page hit an unexpected error. Your data is safe.",
  "d999aeb0545f": "Resolved",
  "da287a6991f2": "Walang templates in this category yet.",
  "da2e1b8c194d": "Mga Card sa Dashboard",
  "da7f99e8cbbf": "Dose",
  "dacfa24d0868": "Pie — Animals by Species",
  "dadccfb55b81": "GOOGLE_CLIENT_SECRET=\"GOCSPX-xxxxx\"",
  "db1affa5c28e": "Folder mapping:",
  "db3ade5935b6": "Impormasyon ng Bukid",
  "dcb45acec258": "Walang assigned tasks.",
  "dcba9bbe1198": "Scanner ng Camera",
  "ddf6a1f0ce8c": "Metrics",
  "df280e8d1006": "Inventory item ID",
  "dfb1cdc86ff6": "Check date *",
  "e0637047e8b6": "Reported by",
  "e070de224434": "Currency",
  "e0cd87951b95": "Nakatalaga employee ID",
  "e1301ae09132": "Buong Backup ng Bukid",
  "e13d1660c248": "Mag-backup Ngayon",
  "e154cb584579": "Target Weight",
  "e184a42b6a65": "I-download Excel (.xlsx)",
  "e24e824b6811": "Nakatalaga",
  "e29a79fe0c34": "Review",
  "e301dd6062f7": "Sex",
  "e542695cd353": "Walang gawain",
  "e570a2dc1297": ", sign out and back in — you'll have access.",
  "e5af0395ec56": "Sex:",
  "e5efd304560a": "none, manual, c-section",
  "e5fac98e866d": "Aprubahan ang mga bagong nag-sign up. Bawiin ang access. Pamahalaan ang bawat account sa bukid — para sa Owner lamang.",
  "e603caadf1f7": "Dashboard ng Admin · Pamamahala ng User",
  "e6d03272a321": "Technician",
  "e6f600b0f54a": "Google Drive folders need initialization",
  "e81a853e3e60": "Numeric Field",
  "e894481d9eed": "Mga Babala Center",
  "e8b685271238": "Fields",
  "e8f43bc66219": "Walang submissions yet. Fill out a template to record one.",
  "e9b1ac9b5406": "Naglo-load farm calendar…",
  "e9bbbb24aa89": "I-save Schedule",
  "e9c45563358e": "Warning",
  "ea26876daa9a": "Natural",
  "ead4b6ef39d4": "Configure the",
  "eada007127e6": "Input / water source",
  "eb5e474d1376": "Cause *",
  "eb9a4bc1c0c1": "Petsa",
  "ecb26f46e394": "Urgent",
  "ecfdad01c3a0": "Your account is pending approval",
  "ed28e0686e12": "Idiskonekta",
  "ed486d652fb9": "Signed Up",
  "ee45c30326b7": "Ulat",
  "eed6bfb41051": "Kinakailangan",
  "ef2c495072dd": "Bagong Weight",
  "efc007a393f6": "I-save",
  "f0cb1033c6f1": "Nursery A",
  "f0d72cd740a1": "Walang audit entries.",
  "f2049c0902fc": "GOOGLE_CLIENT_ID=\"xxxxxxx.apps.googleusercontent.com\"",
  "f219cc0614ae": "Reason",
  "f2c6b564bd81": "Section",
  "f2cc30b13d8e": "Fields (",
  "f3355e26c1d6": "Cough, diarrhea, wound...",
  "f353276e0c59": "Not pregnant",
  "f3ddba3372dd": "tab.",
  "f456d73d894a": "Not recognized as animal tag or employee code",
  "f549dc5349fc": "Urgent items that need attention.",
  "f6b935ab3371": "Unit",
  "f8344ea1a802": "Thank you for signing up,",
  "f8760a38ce49": "Plot name",
  "f8ed4fb0315f": "Cloud backup, PDF uploads, and Sheets sync are live — configure in the",
  "f9060f3f823d": "Scan or enter a code to see details.",
  "fa2984b367b8": "I-save Changes",
  "fb91e24fa52d": "I-update",
  "fba889c720a6": "Male ID (sire) *",
  "fbd71ca491cf": "Dosage",
  "fd1cf782f0a4": "Sire / father (optional)",
  "fd369935a258": "Pag-export ng Datos",
  "fd5b5995a579": "(External) — set app name \"AJ Farm\", your email, and add yourself as a Test User.",
  "fe6434c4ba45": "Metric Key (unique)",
  "ff99f5b5f794": "Simula date",
  "ffcd11eb56e9": "Loss (PHP)"
};
